import { runInAction } from 'mobx';
import { temporaryNotificationDomainStore } from '../temporary-store/store';
export const removeNotification = (id) => {
    runInAction(() => {
        if (id !== undefined) {
            // Remove all notifications with the given ID.
            temporaryNotificationDomainStore.data.notifications =
                temporaryNotificationDomainStore.data.notifications.filter(notification => notification.id !== id);
        }
        else {
            // Pop the first notification
            temporaryNotificationDomainStore.data.notifications.shift();
        }
    });
};
